export default {
    auth: null,

    app: {
        loading: false,
        companySelected: null
    }
};
